export default __webpack_public_path__ + "media/images/mailer/logo-a2fb1781fc72587a95d2e39eaf428d74.png";